export type PublicExaminer = {
  id: string;
  displayName: string;
  bio: string;
  livePlatform: string;
  avatarSeed: string;
  avatarUrl?: string | null;
  online: boolean;
  liveUrl?: string | null;
  liveStartedAt?: string | null;
};

export function splitExaminersLiveFirst(examiners: readonly PublicExaminer[]) {
  const online: PublicExaminer[] = [];
  const offline: PublicExaminer[] = [];

  examiners.forEach((examiner) => {
    if (examiner.online) online.push(examiner);
    else offline.push(examiner);
  });

  return {
    online,
    offline,
    ordered: [...online, ...offline]
  };
}

export function validLiveUrl(examiner: Pick<PublicExaminer, "liveUrl">) {
  if (!examiner.liveUrl) return null;
  try {
    const url = new URL(examiner.liveUrl);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}
